import {Box, useMantineTheme} from "@mantine/core";
import {useEffect} from "@wordpress/element";

export default function LicenseSettings(){
    const theme = useMantineTheme();
    useEffect(() => {
        if(window.appzaPremium){
            window.appzaPremium.licenseArea(theme);
        }
    }, []);

    return(
        <Box id="appza-license-area"></Box>
    )
}